@if (tagGroups()) {
  <div class="tag-wrapper">
    @for (tag of tagGroups(); track tag; let index = $index; let lastTag = $last) {
      @if (!showFullTagList()) {
        @if (index < 3) {
          <app-color-tag
            [withBMargin]="withBMargin()"
            [tag]="tag"
            [isLast]="index === 3 || lastTag">
          </app-color-tag>
        }

      } @else {
        <app-color-tag
          [tag]="tag"
          [isLast]="lastTag">
        </app-color-tag>
      }
    }


    <div class="color-tags">
      @if (!showFullTagList()) {
        <div class="tags-count">
          @if (tagGroups().length > 3) {
            +{{ tagGroups().length - 3 }}
          }
        </div>
      }
      @if (tagGroups().length) {
        <app-divider></app-divider>
      }

      @if (customDateField()) {
        @if (news()[customDateField()]) {
          <app-is-new-tag [newsDate]="news()[customDateField()]  | onlyDate"></app-is-new-tag>
        }
      } @else {
        @if (news().publishDate) {
          <app-is-new-tag [newsDate]="news().publishDate  | onlyDate"></app-is-new-tag>
        }
      }


    </div>

  </div>
}
